import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import { Box, InputLabel, FormControl, NativeSelect } from '@material-ui/core'
import styles from './styles'

const SelectLanguage = props => {
  const { language, setLanguage, classes } = props

  const handleChange = event => {
    setLanguage(event.target.value)
  }
  return (
    <>
      <Box m={2}></Box>

      <FormControl className={classes.formControl}>
        <InputLabel htmlFor="age-native-helper">Language</InputLabel>
        <NativeSelect
          value={language}
          onChange={handleChange}
          inputProps={{
            name: 'age',
            id: 'age-native-helper',
          }}
        >
          <option value={'Arabic'}>Arabic</option>
          <option value={'Simplified Chinese'}>Chinese (Simplified)</option>
          <option value={'Traditional Chinese'}>Chinese (Traditional)</option>
          <option value={'Danish'}>Danish</option>
          <option value={'Dutch'}>Dutch</option>
          <option value={'English'}>English</option>
          <option value={'Finnish'}>Finnish</option>
          <option value={'French'}>French</option>
          <option value={'German'}>German</option>
          <option value={'Italian'}>Italian</option>
          <option value={'Norwegian'}>Norwegian</option>
          <option value={'Polish'}>Polish</option>
          <option value={'Portuguese'}>Portuguese</option>
          <option value={'Russian'}>Russian</option>
          <option value={'Spanish'}>Spanish</option>
          <option value={'Swedish'}>Swedish</option>
          <option value={'Turkish'}>Turkish</option>
          <option value={'Czech'}>Czech</option>
          <option value={'Korean'}>Korean</option>
          <option value={'Vietnamese'}>Vietnamese</option>
          <option value={'Thai'}>Thai</option>
          <option value={'Malay'}>Malay</option>
          <option value={'Romanian'}>Romanian</option>
        </NativeSelect>
      </FormControl>
      <Box m={2}></Box>
    </>
  )
}

export default withStyles(styles)(SelectLanguage)
